export const programPresets = [
  { label: 'Europa', icon: 'europe', filters: ['Europa'], iconUrl: '' },
  { label: 'Azja', icon: 'asia', filters: ['Azja'], iconUrl: '' },
  { label: 'Egzotyka', icon: 'exotic', filters: ['Egzotyka'], iconUrl: '' },
  { label: 'Krótki wyjazd', icon: 'shortTrip', filters: ['Do 5 dni'], iconUrl: '' },
  { label: 'Dłuższa podróż', icon: 'longTrip', filters: ['10 dni i więcej'], iconUrl: '' },
]

export const calendarPresets = [
  { label: 'Zima 2027', icon: 'winter', filters: ['Zima 2027'], iconUrl: '' },
  { label: 'Wiosna 2027', icon: 'spring', filters: ['Wiosna 2027'], iconUrl: '' },
  { label: 'Jesień 2027', icon: 'autumn', filters: ['Jesień 2027'], iconUrl: '' },
  { label: 'Krótki wyjazd', icon: 'shortTrip', filters: ['Do 5 dni'], iconUrl: '' },
  { label: 'Dłuższa podróż', icon: 'longTrip', filters: ['10 dni i więcej'], iconUrl: '' },
]
